/**
 * Category definitions for the FORM Fest map.
 * Each category has a unique color used for button active state and 3D highlights.
 * Array order = button order in the bottom bar (client-specified 18/08/2026).
 */
export const CATEGORIES = [
  {
    id: 'stages',
    label: 'Stages',
    color: '#FF6B35',
    highlightColor: 0xFF6B35,
  },
  {
    id: 'food',
    label: 'Food',
    color: '#8BC34A',
    highlightColor: 0x8BC34A,
  },
  {
    id: 'bars',
    label: 'Bars',
    color: '#E91E90',
    highlightColor: 0xE91E90,
  },
  {
    id: 'camping',
    label: 'Camp',
    color: '#F5C842',
    highlightColor: 0xF5C842,
  },
  {
    id: 'shop',
    label: 'Shop',
    color: '#4A90A4',
    highlightColor: 0x4A90A4,
  },
  {
    id: 'guest-services',
    label: 'Guest Services',
    color: '#E53935',
    highlightColor: 0xE53935,
  },
  {
    id: 'hangouts',
    label: 'Hangouts',
    color: '#9C27B0',
    highlightColor: 0x9C27B0,
  },
  {
    id: 'restrooms',
    label: 'Restrooms',
    color: '#4A90D9',
    highlightColor: 0x4A90D9,
  },
];
